export enum FornecedoresSapEventsEnum {
  Criado = 'fornecedor-cadastrado',
  Removido = 'fornecedor-removido',
  Atualizado = 'fornecedor-atualizado',
}
